import { NgModule, LOCALE_ID, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpService, SessionService, LanguageService } from '@ecp-caf/caf-common';
import { DataTableModule } from '@farris/ui-datatable';
import { FarrisDialogModule } from '@farris/ui-dialog';
import { PaginationModule } from '@farris/ui-pagination';
import { MessagerModule } from '@farris/ui-messager';
import { NotifyModule } from '@farris/ui-notify';
import { ProcessSelectorComponent } from './submit/process-selector/process-selector.component';
import { TaskService } from './runtime/services/task.service';
import { UserService } from './runtime/services/user.service';
import { WfWorkitemHandleComponent } from './runtime/wf-workitem-handle/wf-workitem-handle.component';
import { TaskAssignComponent } from './runtime/components/task-assign/task-assign.component';
import { UserHelperComponent } from './runtime/components/user-helper/user-helper.component';
import { TaskSignaddComponent } from './runtime/components/task-signadd/task-signadd.component';
import { TaskTransferComponent } from './runtime/components/task-transfer/task-transfer.component';
import { WFSubmiteService } from './submit/service/wf-submite.service';
import { AssignParticipantComponent } from './submit/assign-participant/assign-participant.component';
import { DatagridModule } from '@farris/ui-datagrid';
import { WFCommentModule } from '@gsp-wf/ui-comment';
import { I18nService } from './runtime/services/i18n.service';
import { TranslatePipe } from './runtime/services/translate.pipe';
import { ComboListModule } from '@farris/ui-combo-list';
import { LoadingModule } from '@farris/ui-loading';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    DataTableModule,
    FarrisDialogModule,
    PaginationModule,
    NotifyModule,
    MessagerModule.forRoot({
      width: 500
    }),
    DatagridModule,
    WFCommentModule,
    ComboListModule,
    LoadingModule
  ],
  declarations: [
    ProcessSelectorComponent,
    WfWorkitemHandleComponent,
    UserHelperComponent,
    TaskAssignComponent,
    TaskSignaddComponent,
    TaskTransferComponent,
    AssignParticipantComponent,
    TranslatePipe
  ],
  providers: [
    HttpService,
    TaskService,
    UserService,
    SessionService,
    WFSubmiteService,
    I18nService,
    // { provide: LOCALE_ID, useValue: localStorage.getItem('languageCode') || 'zh-CHS' }
  ],
  exports: [
    ProcessSelectorComponent,
    WfWorkitemHandleComponent,
    UserHelperComponent,
    TaskAssignComponent,
    TaskSignaddComponent,
    TaskTransferComponent,
    AssignParticipantComponent,
  ],
  entryComponents: [
    ProcessSelectorComponent,
    WfWorkitemHandleComponent,
    UserHelperComponent,
    TaskAssignComponent,
    TaskSignaddComponent,
    TaskTransferComponent,
    AssignParticipantComponent
  ]
})
export class WFRuntimeModule {
}
